// export array of strings
export const buckets = ['todo', 'in_progress', 'done'];
